export enum NodeTypes {
    Junction = 2,
    NodesWithDestinations = 3,
}